import request from './request';

// 获取基盘导入列表
export function getList(params) {
    return request('/customer/import-record/list', {
        method: 'POST',
        params,
    });
}

// 批量导入
export function importCus(params) {
    return request('/customer/cus-vcl/import', {
        method: 'POST',
        params,
        headers: {
            'Content-Type': 'multipart/form-data',
            // 是否取消统一报错提示
            'Cancel-Message': true,
        },
    });
}
